export * from './header/header.component';
export * from './footer/footer.component';
export * from './search-input/search-input.component';
export * from './custom-modal/custom-modal.component';
export * from './slide-menu/menuitem';
export { SlideMenu, SlideMenuSub, SlideMenuModule } from './slide-menu/slide-menu.component';
